import React, { useState, useEffect } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
// creates a beautiful scrollbar
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import SchoolIcon from "@material-ui/icons/School";
import HotelIcon from "@material-ui/icons/Hotel";
import StorageIcon from "@material-ui/icons/Storage";
import DashboardIcon from "@material-ui/icons/Dashboard";
// core components
import Navbar from "components/Navbars/Navbar.js";
import Footer from "components/Footer/Footer.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import styles from "assets/jss/material-dashboard-react/layouts/adminStyle.js";

import bgImage from "assets/img/sidebar-2.jpg";
import logo from "assets/img/logo2.png";

// Views
import TraineeDashboard from "views/Trainee/TraineeDashboard.js";
import TraineeList from "views/Trainee/TraineeList.js";
import DormitoryManagement from "views/Trainee/DormitoryManagement.js";
import TraineeMasterData from "views/Trainee/TraineeMasterData.js";
import { checkTraineeManagePermission } from "views/Trainee/traineeAuth.js";

let ps;

const useStyles = makeStyles(styles);

export default function TraineeLayout({ ...rest }) {
  const classes = useStyles();
  const mainPanel = React.createRef();
  const [image] = useState(bgImage);
  const [color] = useState("blue");
  const [mobileOpen, setMobileOpen] = useState(false);

  // ตรวจสอบสิทธิ์: เฉพาะ user งานคอมพิวเตอร์ และ งานวิจัยถ่ายทอดเทคโนโลยี (และ Admin) เท่านั้นที่เห็นเมนูจัดการ
  const [canManage, setCanManage] = useState(false);

  useEffect(() => {
    setCanManage(checkTraineeManagePermission());
  }, []);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const getRoute = () => {
    return window.location.pathname !== "/admin/maps";
  };

  const resizeFunction = () => {
    if (window.innerWidth >= 960) {
      setMobileOpen(false);
    }
  };

  useEffect(() => {
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(mainPanel.current, {
        suppressScrollX: true,
        suppressScrollY: false
      });
      document.body.style.overflow = "hidden";
    }
    window.addEventListener("resize", resizeFunction);
    return function cleanup() {
      if (navigator.platform.indexOf("Win") > -1) {
        ps.destroy();
      }
      window.removeEventListener("resize", resizeFunction);
    };
  }, [mainPanel]);

  // กำหนด Routes ตามสิทธิ์: คนอื่นซ่อนให้ดูแค่ dashboard เท่านั้น
  const routes = [
    {
      name: "ภาพรวมระบบ (Dashboard)",
      icon: DashboardIcon,
      component: TraineeDashboard,
      layout: "/trainee",
      path: "/dashboard"
    },
    {
      name: "ข้อมูลแพทย์และนักศึกษา",
      icon: SchoolIcon,
      component: TraineeList,
      layout: "/trainee",
      path: "/list",
      hidden: !canManage
    },
    {
      name: "ระบบจัดการหอพัก/ห้องพัก",
      icon: HotelIcon,
      component: DormitoryManagement,
      layout: "/trainee",
      path: "/dormitory",
      hidden: !canManage
    },
    {
      name: "จัดการข้อมูลหลัก (Master Data)",
      icon: StorageIcon,
      component: TraineeMasterData,
      layout: "/trainee",
      path: "/master-data",
      hidden: !canManage
    }
  ];

  // Routing Switch: หากไม่ใช่ user งานคอมหรือวิจัยถ่ายทอด ให้ Redirect กลับไปที่ dashboard ทันที
  const switchRoutes = (
    <Switch>
      <Route path="/trainee/dashboard" component={TraineeDashboard} />
      {canManage && <Route path="/trainee/list" component={TraineeList} />}
      {canManage && <Route path="/trainee/dormitory" component={DormitoryManagement} />}
      {canManage && <Route path="/trainee/master-data" component={TraineeMasterData} />}
      <Redirect from="/trainee" to="/trainee/dashboard" />
    </Switch>
  );

  return (
    <div className={classes.wrapper} style={{ fontFamily: '"Sarabun", sans-serif' }}>
      <style>{`
        body, button, input, select, textarea, .btn, .badge, .card, .table, .modal {
          font-family: "Sarabun", sans-serif !important;
        }
      `}</style>
      <Sidebar
        routes={routes}
        logoText={"แพทย์ & นศ.ฝึกงาน"}
        logo={logo}
        image={image}
        handleDrawerToggle={handleDrawerToggle}
        open={mobileOpen}
        color={color}
        {...rest}
      />
      <div className={classes.mainPanel} ref={mainPanel}>
        <Navbar
          routes={routes}
          handleDrawerToggle={handleDrawerToggle}
          {...rest}
        />
        {getRoute() ? (
          <div className={classes.content}>
            <div className={classes.container}>{switchRoutes}</div>
          </div>
        ) : (
          <div className={classes.map}>{switchRoutes}</div>
        )}
        {getRoute() ? <Footer /> : null}
      </div>
    </div>
  );
}
